import * as React from "react";
import { SVGProps, memo } from "react";

const BxBxLeftArrowAlt = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.707 17.293L8.414 13H18V11H8.414L12.707 6.707L11.293 5.293L4.586 12L11.293 18.707L12.707 17.293Z" fill="currentColor" /></svg>;

const Memo = memo(BxBxLeftArrowAlt);
export default Memo;